import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import FooterDelphus from '../components/FooterDelphus'
import { mCPF, mValidade } from '../utils/masks'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import logo from '../imgs/logo-salute.png';
import { colors } from '../utils/vars'

const swal = withReactContent(Swal)

function Cartao(props) {
  const [data, setData] = useState([])
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboBan, setComboBan] = useState([{ value: '', display: '' }])
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.id > 0) {
        setComboBan(await api.getComboData('bandeira_cartao'))
        setComboCli(await api.getComboDataWhere('clientes', "?fk_cto=" + query.id))
        api.get('/contratos?pk_cto=' + query.id).then(r => {
          setData(r.data[0])
        })

      }
    }
    fetchData()
  }, [])

  const handleChange = (e) => {
    const auxValues = { ...data };
    auxValues[e.target.name] = e.target.value;
    setData(auxValues);
  };

  function handleSubmit(e) {
    e.preventDefault();
    if ((!data.cvc) || (!data.expiry) || (!data.number) || (!data.name) || (!data.cpf_titular_cartao)) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
        text: "Obrigatório informar nome do titular, cpf, número, validade e cvc do cartão!",
        icon: 'warning',
      })
    } else {

      const auxValues = { ...data };
      api.post('/contratos/cartao', auxValues).then(r => {
        if (r.status === 200) {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Cartão cadastrado<h2>`,
            html: `<p style='color: ${colors.info900}'>Seu cartão foi cadastrado com sucesso!</p>`,
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
        }
      })
    }
  }

  const handleInputFocus = (e) => {
    const auxValues = { ...data };
    auxValues.focus = e.target.name;
    setData(auxValues);
  }


  return (

    <div className="cartao">
      <img alt="logo" src={logo} title="salute" className="cartao_logo" />

      <div className="Manut">

        <div className="ManutContent">
          <div className="defaultHeader">
            <h3>Dados do cartão para pagamento das mensalidades</h3>
          </div>
          <br />
          <div className="cartao">
            <Cards
              cvc={data.cvc || ''}
              expiry={data.expiry || ''}
              focused={data.focus}
              name={data.name || ''}
              number={data.number || ''}
            />

            <form id="searchForm" onSubmit={handleSubmit}>
              <div className="filtersDiv">
                <FrSelect
                  value={data.fk_cli || ''}
                  name="fk_cli"
                  id="fk_cli"
                  label='Nome do Cliente'
                  data={comboCli}
                  style={{ width: 425 }}
                  disabled
                />

                <br />
                <FrTextInput
                  value={data.name || ''}
                  style={{ width: 425 }}
                  name="name"
                  id="name"
                  color="#333333"
                  label="Nome Titular Cartão"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={100}
                  autoFocus
                  onFocus={handleInputFocus}
                />


                <br />
                <FrTextInput
                  value={mCPF(data.cpf_titular_cartao) || ''}
                  style={{ width: 150 }}
                  name="cpf_titular_cartao"
                  id="cpf_titular_cartao"
                  color="#333333"
                  label="CPF Titular Cartão"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={20}
                />
                <br />
                <FrSelect
                  value={data.fk_ban || ''}
                  name="fk_ban"
                  id="fk_ban"
                  label='Bandeira do Cartão'
                  data={comboBan}
                  style={{ width: 300 }}
                  onChange={handleChange}
                />
                <br />
                <FrTextInput
                  value={data.number || ''}
                  style={{ width: 155 }}
                  name="number"
                  id="number"
                  color="#333333"
                  label="Nº Cartão"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={20}
                  onFocus={handleInputFocus}
                />
                <br />
                <FrTextInput
                  value={mValidade(data.expiry) || ''}
                  style={{ width: 140 }}
                  name="expiry"
                  id="expiry"
                  color="#333333"
                  label="Validade (mês/ano)"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={7}
                  onFocus={handleInputFocus}
                />

                <FrTextInput
                  value={data.cvc || ''}
                  style={{ width: 70 }}
                  name="cvc"
                  id="cvc"
                  color="#333333"
                  label="CVC"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={3}
                  onFocus={handleInputFocus}
                />
                <br />
                <FrTextInput
                  value={data.dia_venc || ''}
                  style={{ width: 80 }}
                  name="dia_venc"
                  id="dia_venc"
                  color="#333333"
                  label="Dia Venc."
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={2}
                />
                <label>Dia do mês que vence a fatura do cartão de crédito</label>
              </div>
            </form>
            <div className="regButtons">
              <button onClick={handleSubmit}>Enviar</button>
            </div>


          </div>

          {/* <FooterDelphus /> */}
        </div>
      </div>
    </div>
  );
}

export default Cartao;